import { useIntl } from "react-intl";
import { useNavigate, useParams } from "react-router-dom";

export function Error() {
	const intl = useIntl();
	const { portal, language } = useParams();
	const navigate = useNavigate();

	return (
		<div className="text-center py-4">
			<div className="mb-3">
				<i className="bi bi-x-circle-fill" style={{ color: "#bc231e", fontSize: 64 }}></i>
			</div>
			<h4 className="mb-2">{intl.formatMessage({ id: "error_page_title" })}</h4>

			<p className="text-muted">{intl.formatMessage({ id: "error_page_message" })}</p>
			<div className="mb-2 d-flex flex-column align-items-center gap-2">
				<a
					href="#"
					className="btn btn-link p-0"
					style={{ color: "#bc231e", fontWeight: 600, textDecoration: "underline" }}
					onClick={() => navigate(`/${portal}/${language}`, { replace: true })}
				>
					{intl.formatMessage({ id: "error_page_button" })}
				</a>
			</div>
		</div>
	);
}
